import {AxisLabelsFormatterContextObject, Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class Diff extends AbstractChart {
    protected allChartOptions(): Options {
        const options: Options = {
            chart: {
                type: 'bar',
                width: 660,
                height: 400,
                marginLeft: 40,
                marginRight: 40,
            },
            yAxis: {
                min: -3,
                max: 3,
                tickInterval: 1,
                title: {
                    style: {
                        fontSize: '8pt',
                        color: 'black'
                    }
                },
                labels: {
                    useHTML: true,
                    style: {
                        fontSize: '9pt',
                        color: 'black'
                    },
                    formatter: function (this: AxisLabelsFormatterContextObject) {
                        return Math.abs(<number>this.value).toString();
                    },
                },
            },
            plotOptions: {
                columnrange: {
                    grouping: false
                },
            },
        }

        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {
    registerPlugin(Diff)
}